import { Routes, Route } from "react-router-dom";
import { PublicLayout } from "../components/layouts/PublicLayout";
import { AdminLayout } from "../components/layouts/AdminLayout";
import { RequireAuth, PersistLogin, RedirectIfAuth } from "../components/general";
import {
  Home,
  About,
  Features,
  Pricing,
  SchoolResources,
  TeachersResources,
  ParentsResources,
  BlogDetail,
  PageNotFound,
  Login,
  Signup,
  RequestPasswordReset,
  PasswordReset,
  EmailVerification,
} from "../pages/public";
import {
  Dashboard,
  Students,
  Rooms,
  Staff,
  StudentAttendance,
  StaffAttendanceReport,
  QuranReport,
  Messages,
  Calendar,

  StudentDetails,
  StaffDetails,
  SchoolEdit,
  AddNewSchool,
  AdmissionFormLink,
} from "../pages/admin/js";

import {
  BASE_ROUTE,
  HOME_ROUTE,
  ABOUT_ROUTE,
  SCHOOL_RESOURCES_ROUTE,
  TEACHERS_RESOURCES_ROUTE,
  PARENTS_RESOURCES_ROUTE,
  BLOG_DETAIL_ROUTE,
  FEATURES_ROUTE,
  PRICING_ROUTE,
  LOGIN_ROUTE,
  SIGNUP_ROUTE,
  REQUEST_PASSWORD_RESET_ROUTE,
  PASSWORD_RESET_ROUTE,
  EMAIL_VERIFICATION_ROUTE,
  ADMIN_DASHBOARD_ROUTE,
  ADMIN_STUDENTS_ROUTE,
  ADMIN_STUDENTS_DETAILS_ROUTE,
  ADMIN_ROOMS_ROUTE,
  ADMIN_STAFF_ROUTE,
  ADMIN_STAFF_DETAILS_ROUTE,
  ADMIN_QURAN_REPORT_ROUTE,
  ADMIN_STAFF_ATTENDANCE_ROUTE,
  ADMIN_SCHOOL_EDIT_ROUTE,
  ADMIN_STUDENT_ATTENDANCE_ROUTE,
  ADMIN_ADD_SCHOOL_ROUTE,
  ADMIN_ROOM_STUDENTS_ROUTE,
  ADMIN_MESSAGES_ROUTE,
  ADMIN_CALENDAR_ROUTE,
  ADMIN_ADMISSION_FORM_ROUTE,
  PUBLIC_ADMISSION_FORM_ROUTE,
  ADMIN_ADMISSION_FORM_OVERVIEW_ROUTE,
  ADMIN_ADMISSION_CHILD_DETAILS_ROUTE,
  ADMIN_DOCUMENTS_ROUTE
} from "./RoutesPathes";
import AdmissionFormPublic from "../pages/public/admissionForm/AdmissionFormPublic";
import { AdmissionFormOverview } from "../pages/admin/js/admissionForm/AdmissionFormOverview";
import { AdmissionChildDetails } from "../pages/admin/js/admissionForm/AdmissionChildDetails";
import { Documents } from "../pages/admin/js/documents/Documents";

export const AllRoutes = () => {
  return (
    <Routes>
      {/* Public layout wrapper */}
      <Route element={<PublicLayout />}>
        <Route path={BASE_ROUTE}>
          {/* Render Home component for both / and /home */}
          <Route index element={<Home />} /> {/* Matches / */}
          <Route path={HOME_ROUTE} element={<Home />} />
          <Route path={ABOUT_ROUTE} element={<About />} />
          <Route path={SCHOOL_RESOURCES_ROUTE} element={<SchoolResources />} />
          <Route path={TEACHERS_RESOURCES_ROUTE} element={<TeachersResources />} />
          <Route path={PARENTS_RESOURCES_ROUTE} element={<ParentsResources />} />
          <Route path={BLOG_DETAIL_ROUTE} element={<BlogDetail />} />
          <Route path={FEATURES_ROUTE} element={<Features />} />
          <Route path={PRICING_ROUTE} element={<Pricing />} />
          <Route path={REQUEST_PASSWORD_RESET_ROUTE} element={<RequestPasswordReset />} />
          <Route path={PASSWORD_RESET_ROUTE} element={<PasswordReset />} />
          <Route path={EMAIL_VERIFICATION_ROUTE} element={<EmailVerification />} />
          
          {/* Wrap login/signup in RedirectIfAuth */}
          <Route element={<PersistLogin />}>
            <Route element={<RedirectIfAuth />}>
              <Route path={LOGIN_ROUTE} element={<Login />} />
              <Route path={SIGNUP_ROUTE} element={<Signup />} />
            </Route>
          </Route>
        </Route>
        {/* Catch-all route for 404 */}
        <Route path="*" element={<PageNotFound />} />
      </Route>

      {/* Admin layout wrapper */}
      <Route element={<PersistLogin />}> {/* This component to refresh the token in reloading the page */}
        <Route element={<RequireAuth />}> {/* Protected Router */}
          <Route element={<AdminLayout />}>
            <Route path={ADMIN_DASHBOARD_ROUTE} element={<Dashboard />} />
            <Route path={ADMIN_STUDENTS_ROUTE} element={<Students />} />
            <Route path={ADMIN_STUDENTS_DETAILS_ROUTE} element={<StudentDetails />} />
            <Route path={ADMIN_STAFF_DETAILS_ROUTE} element={<StaffDetails />} />
            <Route path={ADMIN_STUDENT_ATTENDANCE_ROUTE} element={<StudentAttendance />} />
            <Route path={ADMIN_ROOMS_ROUTE} element={<Rooms />} />
            <Route path={ADMIN_ROOM_STUDENTS_ROUTE} element={<Students />} />
            <Route path={ADMIN_STAFF_ROUTE} element={<Staff />} />
            <Route path={ADMIN_QURAN_REPORT_ROUTE} element={<QuranReport />} />
            <Route path={ADMIN_STAFF_ATTENDANCE_ROUTE} element={<StaffAttendanceReport />} />
            <Route path={ADMIN_SCHOOL_EDIT_ROUTE} element={<SchoolEdit />} />
            <Route path={ADMIN_ADD_SCHOOL_ROUTE} element={<AddNewSchool />} />
            <Route path={ADMIN_MESSAGES_ROUTE} element={<Messages />} />
            <Route path={ADMIN_CALENDAR_ROUTE} element={<Calendar />} />
            <Route path={ADMIN_ADMISSION_FORM_ROUTE} element={<AdmissionFormLink />} />
            <Route path={ADMIN_ADMISSION_FORM_OVERVIEW_ROUTE} element={<AdmissionFormOverview />} />
            <Route path={ADMIN_ADMISSION_CHILD_DETAILS_ROUTE} element={<AdmissionChildDetails />} />
            <Route path={ADMIN_DOCUMENTS_ROUTE} element={<Documents />} />
          </Route>
        </Route>
      </Route>
      <Route path={PUBLIC_ADMISSION_FORM_ROUTE} element={<AdmissionFormPublic />} />
    </Routes>
  );
};
